const OPERACIONES = [
  {
    value: 'ope1',
    label: 'Ope 1',
    lugares: [
      { value: 'lugar1', label: 'Lugar 1' },
      { value: 'lugar2', label: 'Lugar 2' },
      { value: 'lugar3', label: 'Lugar 3' },
    ],
  },
  {
    value: 'ope2',
    label: 'Ope 2',
    lugares: [
      { value: 'lugar1', label: 'Lugar 1' },
      { value: 'lugar2', label: 'Lugar 2' },
    ],
  },
  {
    value: 'ope3',
    label: 'Ope 3',
    lugares: [{ value: 'lugar1', label: 'Lugar 1' }],
  },
];

const PARTICIPANTES_BY_LOCATION = {
  'ope1:lugar1': [
    { id: 'tb-ope1-lugar1-01', nombre: 'PEREYRA, OMAR ENRIQUE', legajo: 'TRP000005370' },
    { id: 'tb-ope1-lugar1-02', nombre: 'ROMERO, JULIO ALFREDO', legajo: 'TRP000002150' },
    { id: 'tb-ope1-lugar1-03', nombre: 'PEREZ, LEONARDO GABRIEL', legajo: 'TRP000001919' },
    { id: 'tb-ope1-lugar1-04', nombre: 'GONZALEZ, RUBEN JOSE', legajo: 'TRP000001872' },
    { id: 'tb-ope1-lugar1-05', nombre: 'GOMEZ, JESUS DAVID', legajo: 'TRP000001795' },
  ],
  'ope1:lugar2': [
    { id: 'tb-ope1-lugar2-01', nombre: 'SANTILLAN, CLAUDIO FERNANDO', legajo: 'TRP000001727' },
    { id: 'tb-ope1-lugar2-02', nombre: 'NUNEZ, IVAN HORACIO', legajo: 'TRP000001684' },
    { id: 'tb-ope1-lugar2-03', nombre: 'GIMENEZ, RODRIGO MATIAS', legajo: 'TRP000001641' },
    { id: 'tb-ope1-lugar2-04', nombre: 'MORALES, HERNAN DAVID', legajo: 'TRP000001598' },
    { id: 'tb-ope1-lugar2-05', nombre: 'ACOSTA, EDUARDO DANIEL', legajo: 'TRP000001552' },
  ],
  'ope1:lugar3': [
    { id: 'tb-ope1-lugar3-01', nombre: 'CUEVAS, PABLO JAVIER', legajo: 'TRP000001510' },
    { id: 'tb-ope1-lugar3-02', nombre: 'ORTIZ, LUCAS ADRIAN', legajo: 'TRP000001468' },
    { id: 'tb-ope1-lugar3-03', nombre: 'BENITEZ, MARCELO RAUL', legajo: 'TRP000001427' },
    { id: 'tb-ope1-lugar3-04', nombre: 'MEDINA, CRISTIAN GABRIEL', legajo: 'TRP000001388' },
    { id: 'tb-ope1-lugar3-05', nombre: 'SOSA, GASTON ALEJANDRO', legajo: 'TRP000001346' },
  ],
  'ope2:lugar1': [
    { id: 'tb-ope2-lugar1-01', nombre: 'CABRAL, GABRIEL NICOLAS', legajo: 'TRP000001305' },
    { id: 'tb-ope2-lugar1-02', nombre: 'RAMIREZ, FACUNDO IVAN', legajo: 'TRP000001261' },
    { id: 'tb-ope2-lugar1-03', nombre: 'MARTINEZ, DIEGO ANDRES', legajo: 'TRP000001228' },
    { id: 'tb-ope2-lugar1-04', nombre: 'FERNANDEZ, MATIAS JOSE', legajo: 'TRP000001184' },
    { id: 'tb-ope2-lugar1-05', nombre: 'RUIZ, ALAN ESTEBAN', legajo: 'TRP000001142' },
  ],
  'ope2:lugar2': [
    { id: 'tb-ope2-lugar2-01', nombre: 'LOPEZ, JUAN CRUZ', legajo: 'TRP000001106' },
    { id: 'tb-ope2-lugar2-02', nombre: 'FARIAS, GUSTAVO LEONEL', legajo: 'TRP000001062' },
    { id: 'tb-ope2-lugar2-03', nombre: 'ROMAN, EMILIANO DAVID', legajo: 'TRP000001021' },
    { id: 'tb-ope2-lugar2-04', nombre: 'VELAZQUEZ, EZEQUIEL ARIEL', legajo: 'TRP000000987' },
    { id: 'tb-ope2-lugar2-05', nombre: 'PERALTA, FRANCO NICOLAS', legajo: 'TRP000000941' },
  ],
  'ope3:lugar1': [
    { id: 'tb-ope3-lugar1-01', nombre: 'ROLDAN, NICOLAS EZEQUIEL', legajo: 'TRP000000905' },
    { id: 'tb-ope3-lugar1-02', nombre: 'VARGAS, MARIO ALBERTO', legajo: 'TRP000000862' },
    { id: 'tb-ope3-lugar1-03', nombre: 'PAEZ, RICARDO JOSE', legajo: 'TRP000000826' },
    { id: 'tb-ope3-lugar1-04', nombre: 'GONZALEZ, ENZO LEONARDO', legajo: 'TRP000000781' },
    { id: 'tb-ope3-lugar1-05', nombre: 'MALDONADO, LUIS ALBERTO', legajo: 'TRP000000744' },
  ],
};

const CHARLAS_TOOLBOX = [
  { value: '', label: 'Seleccione una charla' },
  { value: 'charla1', label: 'Charla 1' },
  { value: 'charla2', label: 'Charla 2' },
  { value: 'charla3', label: 'Charla 3' },
];

export function getToolboxOperationOptions() {
  return [{ value: '', label: 'Seleccione Tipo' }, ...OPERACIONES];
}

export function getToolboxPlacesByOperation(operationId) {
  const operation = OPERACIONES.find((item) => item.value === operationId);

  if (!operation) {
    return [{ value: '', label: 'Seleccione Lugar' }];
  }

  return [{ value: '', label: 'Seleccione Lugar' }, ...operation.lugares];
}

export function getToolboxParticipants(operationId, placeId) {
  return PARTICIPANTES_BY_LOCATION[`${operationId}:${placeId}`] || [];
}

export function getToolboxTalkOptions() {
  return CHARLAS_TOOLBOX;
}
